import React, { lazy, Suspense } from 'react';
import TextButton, { Size as TextButtonSize } from '@uds/text-button';
import { cssTheme } from '@uds/theme-utils';
import { useBreakpoints } from '@uds/responsive';

import { RecursiveShortcodeProps } from './Shortcode';

/*
  React-Tooltip is a heavy dependency therefore we asynchronously load it in
  and gracefully decorate the functionality in once it has loaded
*/
const ReactTooltip = lazy(
  () =>
    import(
      /* webpackChunkName: "react-tooltip-lite" */
      'react-tooltip-lite'
    ),
);

const TooltipShortcode = ({ RecursiveShortcode, attributes, elements }: RecursiveShortcodeProps) => {
  const { isMinLg } = useBreakpoints();
  const eventToggle = isMinLg ? undefined : 'onClick';
  const padding = cssTheme.gu2;
  const CallToAction = <TextButton size={TextButtonSize.INHERIT}>{attributes?.label}</TextButton>;

  return (
    <Suspense fallback={CallToAction}>
      {/* @ts-ignore children doesnt exist */}
      <ReactTooltip
        tagName="span"
        eventToggle={eventToggle}
        useDefaultStyles={true}
        padding={padding}
        content={
          <div
            style={{
              maxWidth: 320,
            }}
          >
            {/* @ts-ignore: error when upgrading to @ux/config  */}
            <RecursiveShortcode elements={elements} />
          </div>
        }
      >
        {CallToAction}
      </ReactTooltip>
    </Suspense>
  );
};

TooltipShortcode.displayName = 'TooltipShortcode';

export default TooltipShortcode;
